import type { Document, Folder } from '~/types'

export const useFolderList = () => useState<Folder[]>(() => [])
export const useDocumentList = () => useState<Document[]>(() => [])
export const documentsDataInvalidationTicker = ref(0)
